export const FETCH_ALL_AUTH_OPTIONS = 'FETCH_ALL_AUTH_OPTIONS';
export const FETCH_ALL_NON_AUTH_OPTIONS = 'FETCH_ALL_NON_AUTH_OPTIONS';
